import { deleteBenefitBag } from "../../../infrastructure/repository/benefit-models-repository";
import { displayBenefitPage } from "../../benefit-model/displays/display-benefit-page";
import { showSuccessMessage } from "../../commons/show-success-message";
import { showErrorMessage } from "../../commons/show-error-message";
import { translate as t } from "../../../infrastructure/translate/localization";

export default async function removeBenefitBag({
  companyId,
  benefitPlanId,
  benefitBagConfigId,
  notifyEmployees,
}) {
  const res = await deleteBenefitBag({
    companyId,
    benefitPlanId,
    benefitBagConfigId,
    notifyEmployees,
  });
  displayBenefitPage();

  if (res.status === 200) {
    showSuccessMessage(t("benefits-section.remove-benefit-bag-success"));
  } else {
    showErrorMessage(t(`common-messages.basic-error-message`));
  }
}
